// File Metadata:
// Filename: crewsApiSlice.js
// Version: 1.00
// Created: 2025-03-30 14:31:46
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { apiSlice } from '../../app/api/apiSlice'

export const crewsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCrews: builder.query({
            query: () => '/crews',
            providesTags: ['Crew'],
        }),
        getCrew: builder.query({
            query: (id) => `/crews/${id}`,
            providesTags: (result, error, id) => [{ type: 'Crew', id }]
        }),
        addCrew: builder.mutation({
            query: crew => ({
                url: '/crews',
                method: 'POST',
                body: crew
            }),
            invalidatesTags: ['Crew']
        }),
        updateCrew: builder.mutation({
            query: ({ id, ...crew }) => ({
                url: `/crews/${id}`,
                method: 'PATCH',
                body: crew
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'Crew', id }]
        }),
        deleteCrew: builder.mutation({
            query: (crewId) => ({
                url: `/crews/${crewId}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['Crew']
        }),
        addCrewMember: builder.mutation({
            query: ({ crewId, ...memberData }) => ({
                url: `/crews/${crewId}/members`,
                method: 'POST',
                body: memberData
            }),
            invalidatesTags: (result, error, { crewId }) => [{ type: 'Crew', id: crewId }]
        }),
        removeCrewMember: builder.mutation({
            query: ({ crewId, memberId }) => ({
                url: `/crews/${crewId}/members/${memberId}`,
                method: 'DELETE'
            }),
            invalidatesTags: (result, error, { crewId }) => [{ type: 'Crew', id: crewId }]
        })
    })
})

export const {
    useGetCrewsQuery,
    useGetCrewQuery,
    useAddNewCrewMutation,
    useUpdateCrewMutation,
    useAddCrewMutation,
    useDeleteCrewMutation,
    useAddCrewMemberMutation,
    useRemoveCrewMemberMutation
} = crewsApiSlice
